import * as XLSX from "xlsx";
import { ENTITY_META } from "@/lib/constants";
import { parseAddress } from "@/lib/address";

/**
 * Üye listesini gerçek bir .xlsx dosyası olarak indirir.
 *
 * Arka uçtaki CSV ucu duruyor ama Excel CSV'yi her zaman doğru ayırmıyor
 * (noktalı virgül / Türkçe karakter derdi). Burada dosya tarayıcıda
 * üretiliyor: sütun genişlikleri ayarlı, başlık satırı donuk.
 */
const BASLIKLAR = [
  ["Sıra", 7],
  ["Ad Soyad", 26],
  ["Şirket Adı", 44],
  ["Şirket Türü", 13],
  ["Oy Şekli", 20],
  ["Durum", 15],
  ["Telefon", 22],
  ["Mahalle", 18],
  ["Cadde / Sokak", 22],
  ["Adres", 52],
  ["Üye Sicil No", 13],
  ["Ticaret Sicil No", 15],
  ["Notlar", 46],
];

function satir(m) {
  const em = ENTITY_META[m.entity_type] || ENTITY_META.Firma;
  const { mahalle, sokak } = parseAddress(m.address);
  return [
    m.order_no ?? "",
    m.name || "",
    m.company || "",
    em.long,
    em.vote,
    m.status || "",
    // Çok telefonlu kayıtlarda satır sonu hücreyi bozuyor; ayraçla veriyoruz
    (m.phone || "").split("\n").filter(Boolean).join(" | "),
    mahalle || "",
    sokak || "",
    m.address || "",
    m.member_no || "",
    m.trade_reg_no || "",
    (m.notes || "").replace(/\s*\n\s*/g, " "),
  ];
}

export function uyeleriExcelIndir(members, dosyaAdi) {
  const veri = [BASLIKLAR.map(([ad]) => ad), ...members.map(satir)];
  const sayfa = XLSX.utils.aoa_to_sheet(veri);

  sayfa["!cols"] = BASLIKLAR.map(([, genislik]) => ({ wch: genislik }));
  // Not: satır dondurma (!freeze) bu xlsx sürümünde yazılmıyor, sessizce düşüyor.
  // Başlık satırında süzme okları çıksın
  sayfa["!autofilter"] = {
    ref: XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: veri.length - 1, c: BASLIKLAR.length - 1 },
    }),
  };

  const kitap = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(kitap, sayfa, "Üyeler");

  const bugun = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(kitap, dosyaAdi || `uyeler-${bugun}.xlsx`);
  return members.length;
}
